import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

const Header = ({ onCartClick, onLoginClick }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [cartCount] = useState(3);
  const headerRef = useRef(null);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Sample dropdown data
  const dropdownData = {
    allwatches: [
     
    ],
    men: [
    
    ],
    Women: [
      
    ],
    smart: [
      
    ],
  
    offers: [
     
    ],
   
    
   coporatesale : [
      
    ]
  };

  return (
    <header className="header" ref={headerRef}>
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <span className="logo-text">TimeLessTicK</span>
        </div>

        {/* Navigation Menu */}
        <nav className="nav-menu">
          {Object.entries(dropdownData).slice(0, 8).map(([key, items]) => (
            <div
              key={key}
              className={`nav-item ${activeDropdown === key ? 'active' : ''}`}
              onClick={() => toggleDropdown(key)}
            >
              <span>{key === 'ai-solutions' ? 'AI solutions' : key.charAt(0).toUpperCase() + key.slice(1).replace('-', ' ')}</span>
              
              {activeDropdown === key && (
                <div className="dropdown-menu">
                  {items.map((item, index) => (
                    <div key={index} className="dropdown-item">
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Right Side Actions */}
        <div className="header-actions">
          <div
            className={`action-item ${activeDropdown === 'pricing' ? 'active' : ''}`}
            onClick={() => toggleDropdown('pricing')}
          >
            <span>Pricing</span>
            
            {activeDropdown === 'pricing' && (
              <div className="dropdown-menu pricing-dropdown">
                {dropdownData.pricing.map((item, index) => (
                  <div key={index} className="dropdown-item">
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="action-icon" onClick={closeDropdown}>?</div>
          <div className="action-icon" onClick={closeDropdown}>♡</div>
          <div className="action-icon cart-icon" onClick={onCartClick}>
            🛒
         
          </div>
          <button className="login-btn" onClick={onLoginClick}>Log in</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
